import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import { DriverValueTooltipLegacy } from './DriverValueTooltipLegacy';
import type { DriverProps } from './types';
export const RewardsRate = t0 => {
  const $ = _c(22);
  const {
    creditCardOffer,
    isMonetizing: t1,
    segmentActionSection,
    isRewardsOrSubprimeRU: t2
  } = t0;
  const isMonetizing = t1 === undefined ? true : t1;
  const isRewardsOrSubprimeRU = t2 === undefined ? false : t2;
  const {
    details: t3
  } = creditCardOffer;
  const {
    rewardRateDetails: t4
  } = t3;
  const {
    rateString,
    tooltipString,
    rewardTypeDescription
  } = t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start"
    };
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      display: "flex"
    };
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      marginRight: 1,
      fontSize: "inherit"
    };
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== rateString) {
    t8 = <Typography sx={t7}>{rateString}</Typography>;
    $[3] = rateString;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== isRewardsOrSubprimeRU) {
    t9 = isRewardsOrSubprimeRU && {
      minHeight: 0,
      minWidth: 0,
      containerStyles: {
        position: "relative" as const,
        top: "1px"
      },
      triggerIconHeight: 16,
      triggerIconWidth: 16
    };
    $[5] = isRewardsOrSubprimeRU;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== creditCardOffer.id || $[8] !== isMonetizing || $[9] !== segmentActionSection || $[10] !== t9 || $[11] !== tooltipString) {
    t10 = <DriverValueTooltipLegacy text={tooltipString} ariaLabel="Reward Rate Details" driverKey="rewardsrate" segmentActionSection={segmentActionSection} isMonetizing={isMonetizing} offerId={creditCardOffer.id} {...t9} />;
    $[7] = creditCardOffer.id;
    $[8] = isMonetizing;
    $[9] = segmentActionSection;
    $[10] = t9;
    $[11] = tooltipString;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t8) {
    t11 = <Box sx={t6}>{t8}{t10}</Box>;
    $[13] = t10;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== isRewardsOrSubprimeRU || $[17] !== rewardTypeDescription) {
    t12 = rewardTypeDescription && <Typography variant="bodySmall" sx={{
      textTransform: "capitalize",
      fontSize: isRewardsOrSubprimeRU ? "12px" : "13px"
    }}>{rewardTypeDescription}</Typography>;
    $[16] = isRewardsOrSubprimeRU;
    $[17] = rewardTypeDescription;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <Box sx={t5}>{t11}{t12}</Box>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};